import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_API_URL } from '@cnt-workspace/data-access';
import {
  IListingSearchResponse,
  IPoiSearchResponse,
  ISearchAutocompleteRequest,
  ISearchIndexRebuild,
} from '@curbnturf/entities';
import { objectToUrlParams } from '@curbnturf/helpers';
import { Observable } from 'rxjs';

const API_URL = BASE_API_URL + 'search';

export type SearchIndex = 'poi' | 'listing';

/** Elasticsearch tooling. Replaces @curbnturf/search-components' SearchService (CachedHttpClient). */
@Injectable({ providedIn: 'root' })
export class AdminSearchApiService {
  private readonly http = inject(HttpClient);

  autocomplete(
    index: SearchIndex,
    query: ISearchAutocompleteRequest,
  ): Observable<IPoiSearchResponse | IListingSearchResponse> {
    return this.http.get<IPoiSearchResponse | IListingSearchResponse>(
      `${API_URL}/${index}-autocomplete?${objectToUrlParams(query)}`,
    );
  }

  stats(index: SearchIndex): Observable<{ count: number }> {
    return this.http.get<{ count: number }>(`${API_URL}/${index}/stats`);
  }

  /**
   * Starts dropping and rebuilding every index from PostgreSQL in the background (server
   * AdminAuthGuard); search is degraded meanwhile. 409 when one is already running, with that
   * rebuild as `error.rebuild`.
   */
  startRebuild(): Observable<ISearchIndexRebuild> {
    return this.http.post<ISearchIndexRebuild>(`${API_URL}/indexes/rebuild`, {});
  }

  /** The newest rebuild, running or finished; null if there's never been one. */
  rebuildStatus(): Observable<ISearchIndexRebuild | null> {
    return this.http.get<ISearchIndexRebuild | null>(`${API_URL}/indexes/rebuild`);
  }
}
